import { render, staticRenderFns } from "./MatricesTabCaptura.vue?vue&type=template&id=3ccedcb0&"
import script from "./MatricesTabCaptura.vue?vue&type=script&lang=js&"
export * from "./MatricesTabCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports